import useAuth from 'hooks/useAuth';
import { useInfiniteQuery, useQuery } from 'react-query';
import { IFilterUser } from 'types/user';
import { TTransaction, TTransactions } from 'types/wallet';
import axiosServices from 'utils/axios';
import useParamApi from './useParamAPi';
import { TPaginationData } from 'types/common';

const useTransactionApi = (props: {
    userId?: string | null;
    keyword?: string;
    merchantId?: number | string | null;
    enableTransaction?: boolean;
    enableSearch?: boolean;
    toDate?: string;
    fromDate?: string;
    filter?: IFilterUser & Partial<TTransaction>;
    txId?: string;
}) => {
    const { user } = useAuth();
    const { handleQueryString } = useParamApi();

    const {
        userId,
        keyword = '',
        merchantId = user?.id,
        enableTransaction = false,
        enableSearch = false,
        toDate = '',
        fromDate = '',
        filter = { page: 0, size: 30 },
        txId = ''
    } = props;

    const qGetTransactionsByUserId = useQuery(
        ['qGetTransactionsByUserId', userId],
        () => axiosServices.get(`/v1/wallet/getTransactionsByUserId/${userId}?sortedby=DESC`),
        {
            enabled: Boolean(userId),
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qGetTransactionsAll = useInfiniteQuery(
        [
            `qGetTransactionsAll_${toDate}_${fromDate}_${filter}_${merchantId}_${txId}_${userId}`,
            toDate,
            fromDate,
            filter,
            merchantId,
            txId,
            userId
        ],
        () =>
            axiosServices.get(
                `/v1/wallet/getTransactions/groups${handleQueryString('limit', filter.size, '?')}${handleQueryString(
                    'keyword',
                    txId
                )}${handleQueryString('toDate', filter.created_at)}${handleQueryString('fromDate', filter.created_at)}${handleQueryString(
                    'userId',
                    userId
                )}${handleQueryString('page', filter.page)}${handleQueryString('groupId', merchantId)}${handleQueryString(
                    'type',
                    filter.type
                )}${handleQueryString('status', filter.status)}${handleQueryString(
                    'token_short_name',
                    filter.token_short_name
                )}&order_by=created_at&sorted_by=DESC`
            ),
        {
            enabled: Boolean(merchantId) && enableTransaction,
            refetchInterval: 5000,
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qSearchTransaction = useQuery(
        [`qSearchTransaction_${keyword}_${merchantId}`, keyword, merchantId],
        () =>
            axiosServices.get(
                `/v1/wallet/getTransactions/groups?limit=100&page=0${handleQueryString('keyword', keyword || '~~~~')}${handleQueryString(
                    'groupId',
                    merchantId
                )}`
            ),
        {
            enabled: Boolean(merchantId) && enableSearch,
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qGetTransactionByTxid = useQuery(
        ['qGetTransactionByTxid', txId],
        () => axiosServices.get(`/v1/wallet/getTransactionByTxID/${txId}`),
        {
            enabled: Boolean(txId),
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    return {
        qGetTransactionsByUserId,
        qGetTransactionsByUserIdData: qGetTransactionsByUserId?.data?.data?.data?.results as TTransactions[],
        qGetTransactionsAll,
        dataTransactionAll: qGetTransactionsAll?.data?.pages?.[0]?.data?.data?.results as TTransaction[],
        paginationTransactionAll: qGetTransactionsAll?.data?.pages?.[0]?.data?.data as TPaginationData,
        qGetTransactionByTxid,
        dataTransactionByTxidDetail: qGetTransactionByTxid?.data?.data?.data?.[0] as TTransaction,
        qSearchTransaction,
        dataSearchTransaction: qSearchTransaction?.data?.data?.data?.results as TTransactions[]
    };
};

export default useTransactionApi;
